import React, { useCallback, useState, useEffect, lazy, Suspense } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTypeAdmin, updateStatusTypeAdmin } from "../redux/actions/typeAction"
import Row from "../components/Row"
import { Link } from "react-router-dom";
import './managetype.css'
const Modal = lazy(() => import("../components/Row/modal.js"))

const ManageType = ({ isMobile, closeNav }) => {
    const dispatch = useDispatch()
    const { isLogin, isLoading, userData } = useSelector(state => state.user)
    const { isLoadingTypeAdmin, DataTypeAdmin } = useSelector(state => state.type)
    const [open, setOpen] = useState(false)
    const [dir, setDir] = useState(null)
    const [path, setPath] = useState(null)

    const propsModal = { open, setOpen, dir, setDir, path, setPath }

    useEffect(() => {
        if (isLogin) {
            dispatch(fetchTypeAdmin())
        }
    }, [isLogin])

    const UpdateStatus = useCallback((values) => {
        dispatch(updateStatusTypeAdmin(values))
    }, [DataTypeAdmin]);

    const useStyles = makeStyles(theme => ({
        root: {
            padding: theme.spacing(4, 3)
        },
    }));

    const classes = useStyles();

    return (

        !isLoading &&
        <div className='container h-100vh' style={{ display: closeNav ? 'block' : isMobile ? 'none' : 'block', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-end', padding: !isMobile ? 'none' : '0' }}>
            <Paper className={`${classes.root} col-root`} style={{ boxShadow: 'none', padding: '3%' }}>
                <h3 style={{ fontSize: '38px' }}>จัดการประเภทเอกสาร</h3>
                {userData?.permission?.add_type && <Typography component="div" style={{ padding: '12px' }}>
                    <Link to="add-type" style={{ textDecoration: 'none' }}>
                        <Button
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: "#6ab23a", color: 'white', cursor: 'pointer', borderRadius: '28px'
                            }}>
                            <i style={{ marginRight: '8px' }} className='bx bx-folder-plus icon'></i> เพิ่มประเภทเอกสาร
                        </Button>
                    </Link>
                </Typography>}
                {userData?.permission?.manage_file && <Suspense fallback={<>Loading...</>}>
                    <Modal {...propsModal} />
                </Suspense>}
                <TableContainer component={Paper} style={{ borderRadius: '10px', marginTop: '1%', boxShadow: 'none', maxHeight: '75vh' }}>
                    <Table >
                        <TableHead style={{ backgroundColor: '#464B4F' }}>
                            <TableRow >
                                <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>ชื่อประเภทเอกสาร</TableCell>
                                <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>ชื่อปีเอกสาร</TableCell>
                                <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }} className='col-TableCell'>สถานะ</TableCell>
                                {userData?.permission?.edit_type && <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }}></TableCell>}
                                {userData?.permission?.manage_file && <TableCell style={{ textAlign: 'center', cursor: 'pointer', color: '#fff', fontSize: '18px', fontWeight: 500 }}></TableCell>}
                            </TableRow>
                        </TableHead>
                        {!isLoadingTypeAdmin ? <TableBody style={{ textAlign: 'center' }}>
                            {DataTypeAdmin.map((res, i) => (
                                <Row key={i} index={i} res={res} UpdateStatus={UpdateStatus} {...propsModal} />
                            ))
                            }
                        </TableBody>
                            : <TableBody style={{ margin: 'auto' }}>
                                <TableRow>
                                    <TableCell> <CircularProgress size={30} style={{ color: '#6ab23a' }} /></TableCell>
                                </TableRow>
                            </TableBody>
                        }
                    </Table>
                </TableContainer >
            </Paper>
        </div>
    )
}
export default ManageType